type TAsyncFunc = () => Promise<any>

export class PromiseQueue {
  queue: Array<TAsyncFunc>
  running: boolean
  delay: number

  constructor(params?: { delay?: number }) {
    this.queue = []
    this.running = false
    this.delay = params?.delay || 0
  }

  add(asyncFunc: TAsyncFunc) {
    this.queue.push(asyncFunc)

    this.processQueue()
  }

  private async processQueue() {
    if (this.running || this.queue.length === 0) return

    this.running = true

    const currentPromise = this.queue.shift()

    try {
      await currentPromise()
    } catch (error) {
      console.log(error)
    }

    setTimeout(() => {
      this.running = false
      this.processQueue()
    }, this.delay)
  }
}
